// extracted by mini-css-extract-plugin
export default {"rating-container":"Rating_rating-container__c-gtr"};